/**
 * Storefront domain normalization + validation.
 * Mirrors the server-side rule in
 * order-handler/src/domain/use_cases/v1/use_cases/utils/validate_storefront_domain.ts
 * Keep both in sync.
 */

const DOMAIN_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

export const STOREFRONT_DOMAIN_ERROR = 'Enter your public store domain (e.g. yourstore.com)';
export const STOREFRONT_DOMAIN_MYSHOPIFY_ERROR = 'Enter your public custom domain, not your .myshopify.com address';

// #region normalizeStorefrontDomain
/**
 * Strips scheme, credentials, `www.`, path/query/hash, port and trailing dots,
 * then lowercases. `'https://WWW.YourStore.com/products/x'` -> `'yourstore.com'`.
 */
export const normalizeStorefrontDomain = (value: string): string => {
    if (!value) return '';

    let domain = value.trim().toLowerCase();

    domain = domain.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
    domain = domain.split(/[/?#]/)[0];
    domain = domain.split('@').pop() || '';
    domain = domain.split(':')[0];
    domain = domain.replace(/^www\./, '');
    domain = domain.replace(/\.+$/, '');

    return domain;
};

// #region validateStorefrontDomain
/**
 * `useForm` validation contract: returns an error message, or null when valid.
 */
export const validateStorefrontDomain = (value: string): string | null => {
    const domain = normalizeStorefrontDomain(value);

    if (!domain) return STOREFRONT_DOMAIN_ERROR;
    if (domain.includes('myshopify.com')) return STOREFRONT_DOMAIN_MYSHOPIFY_ERROR;
    if (domain === 'admin.shopify.com' || domain.endsWith('.shopify.com')) return STOREFRONT_DOMAIN_ERROR;
    if (!DOMAIN_PATTERN.test(domain)) return STOREFRONT_DOMAIN_ERROR;

    const tld = domain.split('.').pop() || '';
    if (tld.length < 2) return STOREFRONT_DOMAIN_ERROR;

    return null;
};
